import type { Exception } from "@sentry/types";

export const shouldIgnoreEvent = (exceptions: Exception[] | undefined) => {
  // ignore all the errors that have 4xx or 5xx code
  const ignoredErrorsRegex = /4\d{2}|5\d{2}/;
  return !!exceptions?.every(
    (exception) => exception.value && ignoredErrorsRegex.test(exception.value)
  );
};
